// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__BcaD9","row":"ProcedureTreatmentSummary_row__27alT"};